import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import classes from './nav-bar.module.scss';

type TOption = {
  label: string;
  path: string;
  target?: string;
};

type TNavBarProps = {
  options: TOption[];
};

export const NavBar = ({ options }: TNavBarProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className={classes.root}>
      {options.map(({ path, label, target }) => {
        if (/^https?:\/\//.test(path))
          return (
            <a
              href={path}
              className={classes.menuItem}
              target={target}
              key={label}
            >
              {formatMessage({ id: label })}
            </a>
          );
        return (
          <Link
            to={path}
            className={classes.menuItem}
            key={label}
            target={target}
          >
            {formatMessage({ id: label })}
          </Link>
        );
      })}
    </div>
  );
};
